import './assets/main.css'
import './style/global.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { VueMasonryPlugin } from 'vue-masonry'
import { debugAuthState } from '@/utils/auth'
import { consumeLoginReasonFromUrl } from '@/utils/accountSession'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 导入axios全局拦截器配置
import '@/utils/axios-interceptors'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.use(VueMasonryPlugin)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')

// 登录回调失败记录停用/删除原因（/login?reason=...）
consumeLoginReasonFromUrl()

// 开发环境暴露调试工具到全局
if (import.meta.env.DEV) {
  (window as any).debugAuth = debugAuthState
  console.log('💡 开发模式：可在控制台使用 debugAuth() 查看认证状态')
}
